import React from 'react';
import { Divider } from '@fiverr-private/layout_components';

const MenuDivider = () => <Divider marginY="2" />;

export default MenuDivider;
